export enum SMSModuleEnum {
    Customer = 1,
    Project = 2,
    Offer = 3,
    Coworker = 4,
    Inquiry = 5,
    Planning = 6
}